import packageJson from '../../package.json';

/**
 * App identifier (bundle ID / package name)
 * Used for: Sentry releases, store URLs, etc.
 */
export const APP_ID = 'com.protipster.app';

/**
 * App version configuration
 * Single source of truth: package.json
 *
 * Version format examples:
 * - "1.0.0" - Native release (no OTA updates)
 * - "1.0.0-ota.1" - First OTA update after 1.0.0 native release
 * - "1.0.0-ota.2" - Second OTA update after 1.0.0 native release
 */

/**
 * Full app version (includes OTA suffix if present)
 * Example: "1.0.0-ota.2"
 */
export const APP_VERSION = packageJson.version;

/**
 * Native shell version (base version without OTA suffix)
 * Example: "1.0.0-ota.2" → "1.0.0"
 */
export const NATIVE_VERSION = packageJson.version.split('-')[0];

/**
 * Formatted version string for display
 * Shows "1.0.0-ota.2 (native: 1.0.0)" when OTA, or just "1.0.0" when same
 */
export const getDisplayVersion = () => {
  if (APP_VERSION === NATIVE_VERSION) {
    return APP_VERSION;
  }
  return `${APP_VERSION} (native: ${NATIVE_VERSION})`;
};
